import { memo } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";

import { navItems } from "@/constants/navConfig";
import { cn } from "@/lib/utils";

export const BottomNav = memo(() => {
  const { t } = useTranslation();
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white rounded-t-[22px] shadow-[0_-1px_24px_0_rgba(201,201,201,0.25)] safe-area-bottom z-50"
      role="navigation"
    >
      <div className="flex items-center justify-around h-[75px] max-w-4xl mx-auto">
        {!isLoginPage &&
          navItems.map((item) => {
            const Icon = item.icon;
            const isVoucherMatch =
              item.path === "/vouchers" &&
              location.pathname.startsWith("/my-vouchers");

            return (
              <NavLink
                key={item.path}
                to={item.path}
                preventScrollReset={true}
                className={({ isActive }) =>
                  cn(
                    "flex flex-col items-center justify-center flex-1 h-full gap-[5px] text-sm font-medium transition-all duration-200",
                    isActive || isVoucherMatch
                      ? "text-[#574ADB]"
                      : "text-[#8C929C]",
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <div className="relative w-6 h-6 flex items-center justify-center">
                      <Icon
                        size={24}
                        className="transition-all duration-200"
                        fill={
                          isActive || isVoucherMatch ? "currentColor" : "none"
                        }
                        strokeWidth={isActive || isVoucherMatch ? 2.5 : 2}
                      />
                    </div>
                    <span className="leading-5">{t(item.labelKey)}</span>
                  </>
                )}
              </NavLink>
            );
          })}
      </div>
    </nav>
  );
});

BottomNav.displayName = "BottomNav";
